import { render, staticRenderFns } from "./decoration-excess-form.vue?vue&type=template&id=4bafb85c&scoped=true&"
import script from "./decoration-excess-form.vue?vue&type=script&lang=js&"
export * from "./decoration-excess-form.vue?vue&type=script&lang=js&"
import style0 from "./decoration-excess-form.vue?vue&type=style&index=0&id=4bafb85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafb85c",
  null
  
)

export default component.exports